import {
  Eye,
  Download,
  Send,
  MessageSquare,
  FileText,
  Image,
  File,
  Music,
  Video,
} from "lucide-react";

const QuickMessageBlock = ({ quickMessages = [], onSendQuickMessage }) => {
  const getMessageTypeIcon = (type) => {
    switch (type) {
      case "text":
        return <FileText className="h-5 w-5 text-gray-300" />;
      case "image":
        return <Image className="h-5 w-5 text-green-500" />;
      case "document":
        return <File className="h-5 w-5 text-yellow-500" />;
      case "audio":
        return <Music className="h-5 w-5 text-blue-500" />;
      case "video":
        return <Video className="h-5 w-5 text-purple-500" />;
      default:
        return <MessageSquare className="h-5 w-5" />;
    }
  };

  return (
    <div className="mb-3 grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3">
      {quickMessages.map((qm) => (
        <div
          key={qm.id}
          className="group relative flex flex-col justify-between rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all dark:border-gray-700 dark:bg-gray-800"
        >
          {/* Cabeçalho */}
          <div className="mb-3 flex items-start justify-between">
            <div className="flex items-center space-x-2">
              <span className="text-gray-600 dark:text-gray-300">
                {getMessageTypeIcon(qm.type)}
              </span>
              <h4 className="truncate font-semibold text-gray-900 dark:text-gray-100">
                {qm.title}
              </h4>
            </div>
            <div className="flex flex-wrap gap-2">
              {qm.category && (
                <span className="inline-flex items-center rounded-full bg-blue-100 px-2 py-1 text-xs font-medium text-blue-700 dark:bg-blue-900/30 dark:text-blue-300">
                  {qm.category.charAt(0).toUpperCase() + qm.category.slice(1)}
                </span>
              )}
              {qm.tags?.map((tag, idx) => (
                <span
                  key={idx}
                  className="inline-flex items-center rounded-full bg-green-100 px-2 py-1 text-xs font-medium text-green-700 dark:bg-green-900/30 dark:text-green-300"
                >
                  #{tag}
                </span>
              ))}
            </div>
          </div>

          {/* Conteúdo */}
          <p className="my-3 line-clamp-3 whitespace-pre-wrap text-sm text-gray-700 dark:text-gray-300">
            {qm.content}
          </p>

          {/* Tags e categoria */}

          {/* Botões de ação */}
          <div className="mt-auto flex items-center justify-between border-t border-gray-200 pt-2 dark:border-gray-700">
            {qm.attachmentUrl ? (
              <div className="flex space-x-2">
                <a
                  href={`${process.env.REACT_APP_URL}${qm.attachmentUrl}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-1 rounded bg-blue-50 px-2 py-1 text-xs font-medium text-blue-600 transition-colors hover:bg-blue-100 dark:bg-blue-900/20 dark:text-blue-400 dark:hover:bg-blue-900/40"
                  title="Visualizar arquivo"
                >
                  <Eye className="h-4 w-4" />
                  <span>Ver</span>
                </a>
                <a
                  href={`${process.env.REACT_APP_URL}${qm.attachmentUrl}`}
                  download={qm.attachmentUrl}
                  className="flex items-center space-x-1 rounded bg-green-50 px-2 py-1 text-xs font-medium text-green-600 transition-colors hover:bg-green-100 dark:bg-green-900/20 dark:text-green-400 dark:hover:bg-green-900/40"
                  title="Baixar arquivo"
                >
                  <Download className="h-4 w-4" />
                  <span>Baixar</span>
                </a>
              </div>
            ) : (
              <span className="text-xs text-gray-500 dark:text-gray-400">
                Sem anexo
              </span>
            )}

            <button
              onClick={() => onSendQuickMessage(qm)}
              className="flex items-center space-x-1 rounded bg-green-500 px-3 py-1 text-xs font-medium text-white transition-colors hover:bg-green-600"
            >
              <Send className="h-4 w-4" />
              <span>Inserir</span>
            </button>
          </div>
        </div>
      ))}

      {quickMessages.length === 0 && (
        <div className="col-span-full rounded-lg border border-gray-200 bg-white p-8 text-center dark:border-gray-700 dark:bg-gray-900">
          <MessageSquare className="mx-auto mb-2 h-6 w-6 text-gray-400" />
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Nenhuma mensagem rápida disponível.
          </p>
        </div>
      )}
    </div>
  );
};

export default QuickMessageBlock;
